<template>
  <div class="player">
    <h1 class="score">{{ player.score }}</h1>
    <v-flex class="scoredots" v-for="(score, index) in scores" :key="score.key" @click="addPlayerScore(score, index)">
      {{score.id}}
      <v-icon :class="{ closed: score.value >= 1 }">brightness_1</v-icon>
      <v-icon :class="{ closed: score.value >= 2 }">brightness_1</v-icon>
      <v-icon :class="{ closed: score.value >= 3 }">brightness_1</v-icon>
    </v-flex>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['player'],
  data: () => ({
    dialog: false
  }),
  methods: {
    ...mapActions([
      'addPlayerScore',
      'setGameOver'
    ]),
    addPlayerScore (strike, index) {
      const payload = { 'player': this.player, 'strike': strike, 'index': index }
      this.$store.dispatch('addPlayerScore', payload)
    }
  },
  computed: {
    ...mapGetters([
      'getGameStatus'
    ]),
    scores () {
      return this.$store.state.game.players[this.player.id].strikes
    },
    total_score () {
      return this.$store.state.game.players[this.player.id].total_score
    },
    players () {
      return this.$store.state.game.players
    }
  }
}
</script>
